const serverApp = 'warehousing';

export const environment = {
  serverApp: serverApp,
  production: true,
  apiBaseUrl: 'https://app.bptfl.com/warehousing/customerOnBoarding',
  otpBaseUrl: 'https://client.bptfl.com/api',
  orgUrl: 'https://www.bptfl.com/', // temporary name (replace with actual server and website names)
  pageAccessErrorMsg: 'You are not authorized to view this page.',
  actionAccessErrorMsg: 'You are not authorized to perform this action.',
  siteKey: '0x4AAAAAAClB0rhnzzYznJM_',
};
